import {Badge} from '@mantine/core';
import {PhaseStatus} from '../types.ts';

const colorByStatus: Record<PhaseStatus, string> = {
    [PhaseStatus.PENDING]: 'gray',
    [PhaseStatus.RUNNING]: 'blue',
    [PhaseStatus.SUCCEEDED]: 'green',
    [PhaseStatus.FAILED]: 'red',
    [PhaseStatus.SKIPPED]: 'yellow',
};

export const PhaseStatusBadge = ({status}: { status?: PhaseStatus }) => {
    if (!status) {
        return <Badge color={'gray'} variant={'light'}>UNKNOWN</Badge>;
    }
    return (
        <Badge color={colorByStatus[status] ?? 'gray'} variant={'light'}>
            {status}
        </Badge>
    );
};
